
export default class{

	constructor(){
        this.run(document);
    }
    
    run(d){

        const linkClass = d.querySelectorAll("[data-imgchange-link]");

        if(linkClass.length > 0) {
            linkClass.forEach(element=>{
                console.log("a");
                const linkId =  element.getAttribute('data-link');
                const target = d.querySelector(`[data-img="${linkId}"]`);
                element.addEventListener("mouseenter",() => {
                    target.classList.add("active");
                });

                element.addEventListener("mouseleave",()=>{
                    target.classList.remove("active");
                });
            });
        }
    }
}